/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { HelpModalComponentArgs } from 'cio/components/help-modal';
import { Editor } from 'cio/services/editor';

export default class SwitchToCustomEditorFeedbackForm extends Component<HelpModalComponentArgs> {
  @action
  onSwitchToCustomPayload(e: Event) {
    e.preventDefault();

    this.args.onClose(Editor.JSON);
  }
}
